function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { toast } from 'react-toastify';
import ErrorMsg from './Error';
import SuccessMsg from './Success';
import NoticeMsg from './Notice';
import WarningMsg from './Warning';
var defaultOptions = {
  closeButton: false
};
export default {
  success: function success(props, options) {
    return toast( /*#__PURE__*/React.createElement(SuccessMsg, props), _extends({}, defaultOptions, options));
  },
  error: function error(props, options) {
    return toast( /*#__PURE__*/React.createElement(ErrorMsg, props), _extends({}, defaultOptions, options));
  },
  notice: function notice(props, options) {
    return toast( /*#__PURE__*/React.createElement(NoticeMsg, props), _extends({}, defaultOptions, options));
  },
  warning: function warning(props, options) {
    return toast( /*#__PURE__*/React.createElement(WarningMsg, props), _extends({}, defaultOptions, options));
  }
};